// Shared, pure helpers for the Client Schedule Review feature on the web side.
// Kept framework-free so they can be unit-tested in isolation and reused by the
// share dialog, the public review page, and the producer feedback views.

export type ScheduleShareMode = "concept" | "published";

/** Human-readable label for the share mode, shown as a badge on the client page
 *  and in the producer's share manager. The mode reflects WHERE the producer
 *  shared from: the schedule creator (still editing) -> "Unpublished", the
 *  production portal's schedule view (live) -> "Published". */
export function scheduleModeLabel(mode: ScheduleShareMode | string): string {
  return mode === "published" ? "Published" : "Unpublished";
}

/** Build the full client review link for a token, using the current origin
 *  in the browser (falls back to the production URL on the server). */
export function buildScheduleReviewLink(token: string, origin?: string): string {
  const base = (origin ?? "https://produce-app.com").replace(/\/+$/, "");
  return `${base}/schedule-review?token=${encodeURIComponent(token)}`;
}
